import { ListItemIcon, TextField } from "@mui/material";
import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";
import {
  COMPACT_MOBILE_BREAKPOINT,
  deepPurpleMui,
  greyMui,
  MOBILE_BREAKPOINT,
} from "@ryde/theme";

import { RidesSelectAllWrapper } from "../elements.styled";

export const BulkGridSelectionWrapperStyled = styled(
  RidesSelectAllWrapper,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-grid-selection-wrapper",
})`
  flex-shrink: 0;
  flex-wrap: nowrap;
  gap: 6px;

  svg {
    margin-inline-end: 0;
  }

  .bulk-grid-selection__mode-indicator {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    flex-shrink: 0;

    .select-all-icon {
      font-size: 18px;
      color: ${deepPurpleMui.A700};
    }
  }
`;

export const BulkGridSelectionMenuTriggerStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-grid-selection-menu-trigger",
  },
)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 0;

  .bulk-grid-selection__menu-arrow {
    padding: 2px;
    margin-inline-start: -2px;
    color: inherit;

    svg {
      font-size: 20px;
    }
  }
`;

export const BulkGridSelectionMenuItemIconStyled = styled(
  ListItemIcon,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "bulk-grid-selection-menu-item-icon",
})`
  min-width: 32px;

  .select-all-icon {
    font-size: 20px;
    color: ${deepPurpleMui.A700};
  }
`;

export const BulkGridSelectionRowCountGroupStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "bulk-grid-selection-row-count-group",
  },
)`
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  gap: 2px;

  .bulk-grid-selection__row-count-apply-wrap {
    display: inline-flex;
    cursor: default;

    &[data-can-apply="true"] {
      cursor: pointer;
    }
  }

  .bulk-grid-selection__row-count-apply {
    padding: 2px;
    color: ${deepPurpleMui.A700};
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid ${deepPurpleMui.A700};
      outline-offset: 1px;
    }

    &:disabled,
    &.Mui-disabled {
      color: ${greyMui._400};
      opacity: 1;
      cursor: default;

      svg {
        color: ${greyMui._400};
      }
    }

    svg {
      font-size: 18px;
    }
  }
`;

export const BulkGridSelectionRowCountStyled = styled(TextField)`
  width: 64px;
  flex-shrink: 0;

  .MuiInputBase-input {
    padding: 2px 6px;
    text-align: center;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 52px;

    .MuiInputBase-input {
      padding-inline: 4px;
    }
  }

  @media (max-width: ${COMPACT_MOBILE_BREAKPOINT}) {
    width: 44px;

    .MuiInputBase-input {
      padding-inline: 2px;
    }
  }
`;
